var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"feature-panel",style:({ 'background-image': _vm.featureBackgroundImage }),on:{"click":_vm.navigateToLink}},[_c('div',[_vm._v(_vm._s(_vm.panelText))])])}
var staticRenderFns = []

export { render, staticRenderFns }